
export default {
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      currentIndex: 0,
      touchStartX: 0,
      touchStartY: 0,
      swiping: false,
      frozenImages: []
    }
  },
  created () {
    // Freeze images on creation so parent re-renders don't cause
    // this component to re-render when the array reference changes
    this.frozenImages = Object.freeze([...this.images])
  },
  computed: {},
  watch: {
    images (newVal) {
      // Only update if images actually changed (new hotel images added)
      if (newVal.length !== this.frozenImages.length) {
        this.frozenImages = Object.freeze([...newVal])
      }
    }
  },
  methods: {
    onCarouselClick (e) {
      // On touch devices, prevent the click from bubbling to the card
      if (this.wasTouched) {
        e.stopPropagation()
      }
    },
    onTouchStart (e) {
      this.wasTouched = true
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
      this.swiping = false
      this.scrolling = false
    },
    onTouchMove (e) {
      if (this.scrolling) return
      if (this.swiping) {
        e.preventDefault()
        return
      }
      const dx = Math.abs(e.touches[0].clientX - this.touchStartX)
      const dy = Math.abs(e.touches[0].clientY - this.touchStartY)
      // Lock direction as soon as we detect any meaningful movement
      if (dx > 3 || dy > 3) {
        if (dx >= dy) {
          this.swiping = true
          e.preventDefault()
        } else {
          this.scrolling = true
        }
      }
    },
    onTouchEnd (e) {
      if (this.scrolling) return
      const diff = this.touchStartX - e.changedTouches[0].clientX
      if (Math.abs(diff) > 30) {
        if (diff > 0) {
          this.next()
        } else {
          this.prev()
        }
      }
    },
    prev () {
      this.currentIndex = (this.currentIndex - 1 + this.frozenImages.length) % this.frozenImages.length
    },
    next () {
      this.currentIndex = (this.currentIndex + 1) % this.frozenImages.length
    },
    goToSlide (index) {
      this.currentIndex = index
    }
  }
}
